<template>
	<Modals
		:title="'Change Reason Comment'"
		:display="display"
		:parentTag="'form'"
		:novalidate="'novalidate'"
		@show="close"
	>
		<template #modal-content>
			<Textarea
				:className="'textarea__input'"
				:label="'What changed?'"
				placeholder="Add a comment about the change"
				:rows="5"
				:cols="30"
				:maxLength="200"
				v-model="form.message"
			/>
		</template>
		<template #modal-footer>
			<ButtonGroup
				:items="[
					{
						id: 'saveButtonModal',
						className: 'btn--primary',
						labelText: 'Save Reason',
						type: 'submit',
						btnClick: saveComment,
						disabled: !form.message
					},
					{
						id: 'cancelButtonModal',
						labelText: 'Proceed without Reason',
						btnClick: saveComment
					}
				]"
			/>
		</template>
	</Modals>
</template>

<script>
import Modals from '@/components/shells/modal/modals';
import ButtonGroup from '@/components/forms/button/button-group';
import Textarea from '@/components/forms/textarea/textarea.vue';

export default {
	name: 'FormSaveModal',
	components: {
		Modals,
		Textarea,
		ButtonGroup
	},
	model: {
		prop: 'display',
		event: 'show'
	},
	props: {
		display: {
			type: Boolean,
			default: false
		},
		validateBeforeClose: {
			type: Boolean,
			default: false
		},
		form: {
			type: Object
		},
		refreshList: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		saveComment(e) {
			if (e) e.preventDefault();
			this.$emit('show', false);
		},
		close() {
			this.$emit('cancel');
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * [Description]
    *
    * Add User
    * Can use SCSS variables = TRUE
    *
 */

/*------------------------------------*\
  #BASE
\*------------------------------------*/
::v-deep .modal {
	&__body {
		overflow: initial; //added to fix role dropdown from being cut-off
	}
}

/*------------------------------------*\
  #BASE MOBILE LANDSCAPE-UP
\*------------------------------------*/
@include mq($from: sm-l) {
	.users-info {
		grid-template-columns: 1fr 1fr;
	}
}

/*------------------------------------*\
  #BASE TABLET-UP
\*------------------------------------*/
@include mq($from: md) {
	.users-info {
		width: 550px;
	}
}
</style>
